<template  >


  <v-container style="width:100%;height: calc(100% + 114px);max-width: 100%;margin: 0px 0px 0px;overflow: visible !important;padding:0;" :style="{'backgroundImage':`linear-gradient(${style.start_color},${style.end_color})`}" >


    <div  style="background: url('/api/images/diagmonds.png') repeat;opacity: 0.15;z-index: 0; position: fixed; width: 100%;height: calc(100% + 114px);"></div>


    <v-row class="mx-auto" style="top:100px;width:100%;background: whitesmoke;max-width:1000px;border-radius: 4px;display: block;z-index: 1;position:relative;" align="start" justify="start">
      <v-col style="height:100px;" cols="12">

        <v-tabs color="black" v-model="tab">
          <v-tab>Shop</v-tab>
          <v-tab>Hantera Produkter</v-tab>
          <v-tab>Installera plugin</v-tab>

          <v-spacer></v-spacer>
          <v-btn               v-show="tab===0"
                               @click="save_shop" dark :color="style.start_color" style="top:0;text-shadow: 0px 0px 10px #525252;"><v-icon>mdi-content-save</v-icon> Spara</v-btn>
        </v-tabs>
      </v-col>
      <v-col cols="12" align="start" justify="start">

        <v-tabs-items v-model="tab" style="background: transparent;">
          <v-tab-item>
            <v-row class="px-4"
            >
              <v-col style="margin-left:-20px;" cols="12">
                <v-card flat style="background: transparent;">
                  <v-card-title style="color:gray;">Skapa Hihat-shop för din spelserver</v-card-title>
                </v-card>

              </v-col>

              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field
                    outlined
                    dense
                    v-model="style.shop_name"
                    :counter="30"
                    label="Shoppens namn"
                    required
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-select
                    outlined
                    dense
                    v-model="style.game"
                    :items="['Minecraft','FiveM']"
                    label="Spel"

                ></v-select>
              </v-col>

              <v-col
                  cols="12"
                  md="6"
              >
                <v-textarea
                    outlined
                    dense
                    auto-grow
                    v-model="style.shop_desc"
                    :counter="150"
                    label="Beskrivning av shop"
                    required
                ></v-textarea>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-menu
                    v-model="showImageMenu"
                    absolute
                    offset-y
                    style="max-width: 600px;z-index: 1003;position: absolute;"
                >
                  <template v-slot:activator="{ on }">

                    <v-img
                        v-on="on"
                        style="margin-top:-14px;"
                        aspect-ratio="3"
                        :src="newImage!==null ? newImage : `/api/images/shops/${style.sid}.${style.image}?${Math.round(Math.random()*10000)}`"
                        @error="function(){}"
                        class="hover-darken2"
                        contain
                        v-ripple
                    >
                      <v-chip label>Shop Logo</v-chip>

                    </v-img>
                  </template>

                  <v-list >
                    <v-list-item @click="updateHeaderImage">
                      <v-list-item-title><v-icon left>mdi-image-plus</v-icon>Byt bild</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="removeHeaderImage">
                      <v-list-item-title><v-icon left>delete</v-icon>Ta bort bild</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field


                    v-model="style.shop_path"
                    outlined
                    label="URL"
                    dense

                    hide-details
                    :prefix="'hihat.io/'"
                >
                  <v-btn small v-clipboard:copy="'https://hihat.io/'+style.shop_path"  slot="append" icon >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                  <v-btn small @click="go_to"  slot="append" icon >
                    <v-icon>mdi-monitor-cellphone</v-icon>
                  </v-btn>



                </v-text-field>
              </v-col>

              <v-col cols="3" style="margin-top: -8px;">
                <v-menu
                    v-model="menuStart"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                    content-class="color_menu"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                        style="z-index: 1000;text-shadow: 0px 0px 10px #525252;"
                        dark
                        class="mx-2 my-2"
                        :color=style.start_color
                        v-on="on"

                        block
                    >Färg 1</v-btn>
                  </template>
                  <v-color-picker style="z-index: 1000;" @input="changeStart" :value=style.start_color class="ma-2" hide-inputs></v-color-picker>
                </v-menu>
              </v-col>
              <v-col cols="3" style="margin-top: -8px;">



                <v-menu

                    v-model="menuEnd"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-x
                    content-class="color_menu"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                        style="z-index: 1;text-shadow: 0px 0px 10px #525252;"
                        dark
                        :color=style.end_color
                        block

                        class="mx-2 my-2"
                        v-on="on"
                    >Färg 2</v-btn>
                  </template>
                  <v-color-picker  @input="changeEnd" :value=style.end_color class="ma-2" hide-inputs></v-color-picker>
                </v-menu>

              </v-col>






            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row class="px-4"
            >
              <v-col cols="12">
                <v-btn text color="green" @click="add_new_product"><v-icon>mdi-plus</v-icon>Lägg till</v-btn>

              </v-col>
              <v-col cols="12" style="height:100%;">
                <v-row style="max-height:calc(70vh - 100px);height:height:calc(70vh - 100px);overflow-y:scroll;">
                  <v-col v-for="(product,index) in products" :key="index" cols="12">
                    <v-card
                        class="mx-auto"
                        style="max-width:500px;height:160px;"
                        @click="change_product(index)"

                    >
                      <v-list-item two-line>
                        <v-list-item-content>
                          <div class="text-overline mb-4">
                            {{ product.PRICE }} kr
                          </div>
                          <v-list-item-title class="text-h5 mb-1">
                            {{ product.NAME }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ product.DESC }}

                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-img
                          style="width:150px;height:150px;position:absolute;right:5px;top:5px;border-radius: 4px;"
                          aspect-ratio="1"
                          :src="product.NEW_IMAGE!==null? product.NEW_IMAGE:`/api/images/shop_products/${product.PRID}.png?${Math.round(Math.random()*10000)}`"
                          @error="function(){}"

                          class="mx-auto"
                      >


                      </v-img>




                    </v-card>
                  </v-col>
                </v-row>

              </v-col>

            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-list v-if="style.game==='Minecraft'">
              <v-list-item class="mb-4" two-line>
                <v-list-item-content>
                  <v-list-item-title>1. Installera plugin</v-list-item-title>
                  <v-list-item-subtitle>Ladda ner <a href="https://hihat.io/api/hihat_shop.jar">hihat_shop.jar</a> och placera den i din servers plugins-mapp.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item  two-line>
                <v-list-item-content>
                  <v-list-item-title @click="download_secret">2. Ladda ner Hihat-nyckel</v-list-item-title>
                  <v-list-item-subtitle>Ladda ner filen <a @click="download_secret">hihat_secret.txt</a> och placera den i din server-mapp.</v-list-item-subtitle>

                </v-list-item-content>
              </v-list-item>
              <v-treeview
                  class="mb-4"
                  v-model="tree"
                  :items="items"
                  :open="['plugins']"
                  activatable
                  item-key="name"
                  open-on-click
              >
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
              </v-treeview>
              <v-list-item class="mb-4"  two-line>
                <v-list-item-content>
                  <v-list-item-title>3. Starta din server</v-list-item-title>
                  <v-list-item-subtitle>Starta upp din server</v-list-item-subtitle>
                  <v-list-item-subtitle><span style="background:#818181;color:#eeeeee;margin-right:4px;font-family: 'Roboto Mono', Monaco, courier, monospace"><b>"Hihat Plugin loaded successfully"</b></span> visas i konsolen.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mb-4"  three-line>
                <v-list-item-content>
                  <v-list-item-title>4. Testa anslutning </v-list-item-title>
                  <v-list-item-title> <v-btn :loading="send_button_loading" small @click="test_connection">Skicka test</v-btn></v-list-item-title>

                  <v-list-item-subtitle><span style="background:#818181;color:#eeeeee;margin-right:4px;font-family: 'Roboto Mono', Monaco, courier, monospace"><b>"Hihat is connected"</b></span> visas i konsolen inom 15 sekunder.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>




            </v-list>
            <v-list v-else-if="style.game==='FiveM'">
              <v-list-item class="mb-4" two-line>
                <v-list-item-content>
                  <v-list-item-title>1. Installera Hihat-resource</v-list-item-title>
                  <v-list-item-subtitle>Ladda ner <a href="https://hihat.io/api/hihat_shop.zip">hihat_shop.zip</a> och placera mappen bland dina resources. Inkludera <span style="background:#818181;color:#eeeeee;margin-right:4px;font-family: 'Roboto Mono', Monaco, courier, monospace"><b>ensure/start hihat_shop</b></span> i server.cfg/resources.cfg </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item  two-line>
                <v-list-item-content>
                  <v-list-item-title @click="download_secret">2. Ladda ner Hihat-nyckel</v-list-item-title>
                  <v-list-item-subtitle>Ladda ner filen <a @click="download_secret">hihat_secret.txt</a> och placera den i din server-mapp.</v-list-item-subtitle>

                </v-list-item-content>
              </v-list-item>
              <v-treeview
                  class="mb-4"
                  v-model="tree"
                  :items="items"
                  :open="['plugins']"
                  activatable
                  item-key="name"
                  open-on-click
              >
                <template v-slot:prepend="{ item, open }">
                  <v-icon v-if="!item.file">
                    {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                  </v-icon>
                  <v-icon v-else>
                    {{ files[item.file] }}
                  </v-icon>
                </template>
              </v-treeview>
              <v-list-item class="mb-4"  two-line>
                <v-list-item-content>
                  <v-list-item-title>3. Starta din server</v-list-item-title>
                  <v-list-item-subtitle>Starta upp din server</v-list-item-subtitle>
                  <v-list-item-subtitle><span style="background:#818181;color:#eeeeee;margin-right:4px;font-family: 'Roboto Mono', Monaco, courier, monospace"><b>"hihat_secret.txt OK"</b></span> visas i konsolen.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="mb-4"  three-line>
                <v-list-item-content>
                  <v-list-item-title>4. Testa anslutning </v-list-item-title>
                  <v-list-item-title> <v-btn :loading="send_button_loading" small @click="test_connection">Skicka test</v-btn></v-list-item-title>

                  <v-list-item-subtitle><span style="background:#818181;color:#eeeeee;margin-right:4px;font-family: 'Roboto Mono', Monaco, courier, monospace"><b>"Hihat is connected"</b></span> visas i konsolen inom 15 sekunder.</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>




            </v-list>


          </v-tab-item>
        </v-tabs-items>
      </v-col>



    </v-row>
    <v-dialog
        v-model="add_item_dialog"
        max-width="600px"
    >

      <v-card>
        <v-card-title>
          <span class="text-h5">Hantera produkt</span>
          <v-spacer></v-spacer>
          <v-btn  @click="delete_product" icon color="#b92d1a"><v-icon>mdi-delete</v-icon></v-btn>
        </v-card-title>
        <v-card-text >
          <v-container v-if="add_item_dialog" style="overflow: visible !important;" >
            <v-row >
              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field
                    outlined
                    v-model="products[product_to_check].NAME"
                    label="Produktnamn*"
                    required
                ></v-text-field>
              </v-col>
              <v-col
                  cols="12"
                  md="6"
              >
                <v-text-field
                    outlined
                    v-model="products[product_to_check].PRICE"
                    label="Pris* (inkl. 25% moms)"
                    suffix="kr"
                    required
                    type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" justify="center">


                    <v-img
                        style="width:200px;height:200px;"
                        aspect-ratio="1"
                        :src="products[product_to_check].NEW_IMAGE!==null? products[product_to_check].NEW_IMAGE:`/api/images/shop_products/${products[product_to_check].PRID}.png?${Math.round(Math.random()*10000)}`"
                        @error="function(){}"

                        class="hover-darken2 mx-auto"
                        v-ripple
                        @click="updateProductImage"
                    >
                      <div style="width:100%;height:100%;background-image:linear-gradient(whitesmoke,antiquewhite);opacity:0.1;">
                        <v-icon style="top:80px;left:80px;" x-large>mdi-camera</v-icon>
                      </div>


                    </v-img>


              </v-col>
              <v-col
                  cols="12"
                  md="12"
              >
                <v-textarea
                    outlined
                    label="Produktbeskrivning"
                    v-model="products[product_to_check].DESC"

                    rows="2"
                ></v-textarea>
              </v-col>

              <v-col
                  cols="12"
                  md="12"
                  style="margin-top:-40px;"
              >
                <v-textarea
                    outlined
                    rows="2"
                    v-model="products[product_to_check].COMMAND"


                    label="Kommando (körs på din server vid köp)"
                ></v-textarea>
              </v-col>
              <v-col
                  style="margin-top:-40px;margin-bottom:-40px;"
                  cols="12"
                  md="12"
                  v-html="'Tillgängliga variabler: <b>{username}</b> <br>Exempel: give {username} diamond_axe'"
              >


              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              text
              color="green"
              @click="add_item_dialog = false"
          >
            Spara
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <input id="headerInput" style="display:none;" type="file" accept="image/*"   v-on:change="openHeaderFile">
    <input id="productInput" style="display:none;" type="file" accept="image/*"   v-on:change="openProductFile">








  </v-container>

</template>

<script>


export default {
  name: "MyShop",
  components:{},
  data:function(){
    return{
      files: {
        jar: 'mdi-language-java',
        txt: 'mdi-file-document-outline',
        exe: 'mdi-application-outline',

      },
      tree: [],
      items: [
        {
          name: 'min_server',
          children: [
            {
              name: 'resources',
              children: [
                {
                  name: 'hihat_shop',
                }

              ],
            },
            {
              name: 'hihat_secret.txt',
              file: 'txt',
            },
            {
              name: 'FXserver.exe',
              file: 'exe',
            }

          ],
        },


      ],
      showProductImageMenu:false,
      product_to_check:0,
      add_item_dialog:false,
      products:[
      ],
      showImageMenu:false,
      style:{
        sid:0,
        shop_name:"",
        shop_desc:"",
        shop_path:"",
        is_dark:false,
        start_color:"#48b983",
        end_color:"#4edaba",
        secret:null,
        image:"png",
        game:"Minecraft"
      },
      menuStart:false,
      menuEnd:false,
      force_get_style:false,
      shop_key:"hgeqokjjn12312145km",
      newImage:null,
      tab:0,
      send_button_loading:false,
      has_forced_once:false





    }
  },
  methods:{

    download_secret:function(){
      var a = window.document.createElement('a');
      a.href = window.URL.createObjectURL(new Blob([this.style.secret], {type: 'text/text'}));
      a.download = 'hihat_secret.txt';

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
    },


    go_to(){

      window.open(`https://hihat.io/${this.style.shop_path}`, '_blank').focus();
    },



    delete_product(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let product_index=this.product_to_check;

      let url = '/api/save_shop_products?';
      this.products[product_index].IS_DELETED=1;
      let params="&PRODUCTS="+JSON.stringify([this.products[product_index]]);

      //PATH,MIN_DONATION,TITLE,SUGGESTION_ONE,SUGGESTION_TWO,SUGGESTION_THREE FROM
      http.open('POST', url, true);
      let self=this;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.

        if(http.readyState === 4 && http.status === 200){
          self.add_item_dialog=false;
          self.product_to_check=0;
          self.get_shop_products();


        }
      }



      http.send(params);
    },

    save_products(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/save_shop_products?';
      let params="&PRODUCTS="+JSON.stringify(this.products);

      //PATH,MIN_DONATION,TITLE,SUGGESTION_ONE,SUGGESTION_TWO,SUGGESTION_THREE FROM
      http.open('POST', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.

        if(http.readyState === 4 && http.status === 200){
          console.log("saved")


        }
      }



      http.send(params);
    },


    get_shop_products(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let self=this;
      let url = '/api/get_shop_products?path='+this.style.shop_path;
      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.


        if(http.readyState === 4 && http.status === 200){
          let resp=JSON.parse(http.responseText);
          let products=resp.products;

          for(let i=0;i<products.length;i++){
            products[i].NEW_IMAGE=null;
          }
          self.products=products;




        }

      };
      http.send();
    },

    add_new_product(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/add_shop_product?';


      //PATH,MIN_DONATION,TITLE,SUGGESTION_ONE,SUGGESTION_TWO,SUGGESTION_THREE FROM
      http.open('POST', url, true);
      let self=this;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.

        if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);
          if(("PRID" in data)){
            self.products.push({
              NAME:"Ny Produkt",
              PRICE:100,
              DESC:"",
              PRID:data.PRID,
              COMMAND:"",
              NEW_IMAGE:null,
              IS_DELETED:0
            })
            self.product_to_check=self.products.length-1;
            self.add_item_dialog=true;
          }


        }
      }



      http.send();
    },

    change_product(index){
      this.product_to_check=index;
      this.add_item_dialog=true;
    },


    test_connection(){
      this.send_button_loading=true;
      let self=this;

      setTimeout(function(){
        self.send_button_loading=false;
      },1500)
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api/test_command?secret='+this.style.secret;
      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

      http.send();
    },



    save_shop(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;

      let url = '/api/save_shop?';
      let header="nvm";


      if(this.newImage!==null){
        header=this.newImage.replace('url(','').replace(')','').replace(/"/gi, "")
      }
      this.style.shop_path=this.style.shop_path.replace(/\W/g, '')
      this.style.shop_path=this.style.shop_path.replace(' ', '');

      let params ='PATH='+this.style.shop_path+'&SHOP_NAME='+this.style.shop_name+'&IS_DARK='+this.style.is_dark+'&START_COLOR='+this.style.start_color+'&END_COLOR='+this.style.end_color+'&SHOP_DESC='+this.style.shop_desc+'&IMAGE='+header+'&GAME='+this.style.game;

      //PATH,MIN_DONATION,TITLE,SUGGESTION_ONE,SUGGESTION_TWO,SUGGESTION_THREE FROM
      http.open('POST', url, true);
      let self=this;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.

        if(http.readyState === 4 && http.status === 200){
            self.getStyleData();


        }
      }



        http.send(params);

    },

    saveProductImage: function(image,prid){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api/save_product_image?';
      let params="IMAGE="+image+"&PRID="+prid;
      http.open('POST', url, true);

      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {

        if(http.readyState === 4 && http.status === 403) {

          console.log("error");

        }
        else if(http.readyState === 4 && http.status === 200){
          console.log("nice")

        }

      };
      http.send(params);
    },


    changeStart(e){
      this.style.start_color=e;
      //this.$store.state.STYLE.START_COLOR=e;
    },
    changeEnd(e){
      this.style.end_color=e;

      //this.endColor=e;
    },

    openProductFile:function(file){
      let input = file.target;


      let reader = new FileReader();
      let self=this;
      reader.onload = function(){
        //self.products[self.product_to_check].I=reader.result;
        self.saveProductImage(reader.result,self.products[self.product_to_check].PRID)
        self.products[self.product_to_check].NEW_IMAGE=reader.result;
      };
      reader.readAsDataURL(input.files[0]);
    },

    openHeaderFile:function(file) {

      let input = file.target;


      let reader = new FileReader();
      let self=this;
      reader.onload = function(){
        self.newImage=reader.result;
        self.style.IMAGE=true;
        self.save_shop();
      };
      reader.readAsDataURL(input.files[0]);
    },
    updateHeaderImage:function(){
      document.getElementById("headerInput").click();
    },

    updateProductImage:function(){
      document.getElementById("productInput").click();
    },
    removeHeaderImage:function(){
      this.style.IMAGE=false;
    },
    getStyleData(){
      this.doneFetching=false;
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let url = '/api/getShopStyle?';
      let pathname=window.location.pathname.substring(1);

      http.open('POST', url, true);
      let index=pathname.indexOf("?");
      if(index>0){
        pathname=pathname.substr(0,index);
      }
      let self=this;
      document.title=pathname;
      this.path=pathname;
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.

        if(http.readyState === 4 && http.status === 200){
          let data = JSON.parse(http.response);
          console.log(data);
          if(!("error" in data)){
            self.style.start_color=data.START_COLOR;
            self.style.end_color=data.END_COLOR;
            self.style.shop_name=data.SHOP_NAME;
            self.style.shop_desc=data.SHOP_DESC;
            self.style.secret=data.SECRET;
            self.style.shop_path=data.PATH;
            self.style.is_dark=data.IS_DARK===1;
            self.style.sid=data.SID;
            self.style.image=data.IMAGE;
            self.style.game=data.GAME;

            self.get_shop_products();
          }


        }

      };
      http.send();
    },

    get_bcf_status:function(){
      let http = new XMLHttpRequest();
      http.withCredentials = true;
      let self=this;
      let url = '/api/in_bcf?path='+window.location.pathname.substring(1);
      http.open('GET', url, true);
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      http.onreadystatechange = function() {//Call a function when the state changes.


        if(http.readyState === 4 && http.status === 200){
          let resp=JSON.parse(http.responseText);
          if(resp["in_bcf"]){
            self.in_bcf=true;
          }else{
            self.in_bcf=false;

          }




        }

      };
      http.send();
    }


  },
  mounted:function(){
    this.getStyleData();
    document.title="Min Shop";







  },
  computed:{
    cardCost:function(){
      let total=0;

      for(let i=0;i<this.order.length;i++){
        total+=this.order[i].count*this.order[i].product.PRICE;
      }
      return total
    },
    order:function(){
      let toReturn={};
      for(let i=0;i<this.basket.length;i++){
        if(toReturn[this.basket[i].UID]===undefined || toReturn[this.basket[i].UID]===null){
          toReturn[this.basket[i].UID]={
            count:0,
            product:this.basket[i]
          }
        }
        toReturn[this.basket[i].UID].count+=1;

      }
      return Object.values(toReturn);


    },

    payments_setup:function(){

      if(this.$store.state.STREAMER.PAYMENT_TYPE==="SWISH" && this.$store.state.STREAMER.PHONE_NUMBER.length>6){
        return true
      }
      else if(this.$store.state.STREAMER.PAYMENT_TYPE==="BANK" && this.$store.state.STREAMER.BANKACCOUNT.length>6 && this.$store.state.STREAMER.PERSONAL_NUMBER.length>6){
        return true
      }
      else{
        return false
      }

    },
    need_setup:function(){
      if(this.style.IS_SETUP===1){
        return false
      }
      else if(this.style.IS_SETUP===0){
        return true
      }
      else{
        return false
      }
    },
    alerts_setup:function(){
      return (this.$store.state.STREAMER.STREAMELEMENTS || this.$store.state.STREAMER.STREAMLABS || this.$store.state.STREAMER.HIHAT)
    },
    dark_mode_text:function(){
      if(this.style.SUGGESTION_TWO){
        return "Mörkt tema"
      }
      else{
        return "Ljust tema"

      }
    },

    ready_to_pay:function(){
      if(parseInt(this.amount_selected)>=parseInt(this.style.MIN_DONATION) && this.accept_terms && this.sender_name.length>2 && this.message.length<250 ){
        let res=this.phone_number.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
        if(res===0){
          return true
        }
        else{
          return false
        }
      }
      else{
        return false
      }
    },
    ready_to_pay_hicards:function(){
      if(this.basket.length>0 && this.accept_card_terms && this.recipient_name.length>2){
        let res=this.phone_number.search(/^(([+]46)\s*(7)|07)[02369]\s*(\d{4})\s*(\d{3})$/gm);
        if(res===0){
          return true
        }
        else{
          return false
        }
      }
      else{
        return false
      }
    },
    payment_status:function(){
      if(this.$route.query.result===undefined){
        return false;
      }
      else{
        return true;
      }

    },
    payment_result:function(){
      if(this.$route.query.result===undefined){
        return ""
      }
      else{
        return this.$route.query.result
      }
    }

  },
  watch:{
    add_item_dialog:function(){
      if(!this.add_item_dialog){
        this.save_products();
      }
    },


    recipient_name:function(){
      if(this.recipient_name!==""){
        this.get_name_suggestions();
      }else{
        this.name_suggestions=[];
      }
    },
    '$route': function () {
      this.getStyleData();
    }








  }
}



</script>

<style >

.force_height .v-window__container{
  height:400px;
}

.shadowed{
  color: rgb(255 255 255);
  text-shadow: 2px 2px 2px #b8b8b8;
}
.green_grad{
  background: linear-gradient(0deg, rgba(9,108,7,1) 0%, rgba(32,142,39,1) 35%, rgba(16,218,5,1) 100%) !important;
}

.blue_grad{
  background: linear-gradient(0deg, rgba(8,46,180,1) 0%, rgba(41,62,213,1) 35%, rgba(0,138,255,1) 100%) !important;
}

.purple_grad{
  background: linear-gradient(0deg, rgba(88,8,180,1) 0%, rgba(150,41,213,1) 35%, rgba(154,0,255,1) 100%) !important;
}

.orange_grad{
  background: linear-gradient(0deg, rgba(180,106,8,1) 0%, rgba(213,145,41,1) 35%, rgba(255,196,0,1) 100%) !important;
}
.digi{
  font-family: 'Galindo', cursive;
  font-weight:500;

}

.faded_img{
  filter:saturate(0) brightness(300%);
}

.put_me_down > .v-input__control {
  margin-top: 7px!important;
}
.hover-darken:hover{
  background:rgba(0,0,0,0.1);
}

.display-1 > * input{
  max-height:40px !important;
}

.no_elevate{
  box-shadow:none;
}

.no_scroll > * textarea{
  overflow:hidden;
}

.to_the_left{
  position: relative;
  left:-34px;
}

.hover-darken2:hover{
  opacity:0.9;
  cursor: pointer;
}

.flex-center > * .v-input__slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 10px;

}

.color_menu{
  min-width: 0 !important;
}

.color_menu > div{
  margin:0 !important;
}

.v-tabs-bar{
  background: transparent !important;
}




</style>
